<template>
  <div>
    <div class="desktop">
      <section class="linker-spec-hero">
        <span>Linker의 기술사양</span>
      </section>
      <section class="specs-detail">
        <div class="spec">
          <div class="linker-spec-title">
            <span>구성</span>
          </div>
          <div class="linker-spec-description">
            <div class="img-container"><img src="@/assets/linker/spec-detail-linker.png" alt="">
              <p class="name">링커</p>
            </div>
            <div class="img-container linker-mid-img"><img src="@/assets/linker/spec-detail-adaptor.png" alt="">
              <p class="name">전원 어댑터</p>
            </div>
            <div class="img-container"><img src="@/assets/linker/spec-detail-cable.png" alt="">
              <p class="name">전원 케이블 1.5M</p>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="linker-spec-title">
            <span>크기 및 무게</span>
          </div>
          <div class="linker-spec-description dimension">
            <div>
              <span class="dimension-title">크기</span>
              <div class="dimension-description">
                <p>가로: 10cm</p>
                <p>세로: 10cm</p>
                <p>두께: 3.5cm</p>
              </div>
            </div>
            <div style="vertical-align: top;">
              <span class="dimension-title">무게</span>
              <div class="dimension-description">
                <p>145g</p>
              </div>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="linker-spec-title"><span>색상</span></div>
          <div class="linker-spec-description">
            <p>유광 블랙</p>
          </div>
        </div>
        <div class="spec">
          <div class="linker-spec-title"><span>지원 기기</span></div>
          <div class="linker-spec-description">
            <p>iOS,Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="spec">
          <div class="linker-spec-title"><span>연결</span></div>
          <div class="linker-spec-description">
            <p>적외선(IR)센서 38kHz</p>
            <p>Bluetooth 4.0</p>
            <p>Wi-Fi</p>
          </div>
        </div>
        <div class="spec">
          <div class="linker-spec-title"><span>요구사항</span></div>
          <div class="linker-spec-description">
            <p>Wi-Fi 2.4GHz (5Ghz는 지원 X)</p>
            <p>적외선(IR)이 지원되는 호환기기</p>
          </div>
        </div>
        <div class="spec" style="margin-bottom: 90px;">
          <div class="linker-spec-title"><span>보안</span></div>
          <div class="linker-spec-description">
            <p>WPA, WPA2, WEP</p>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile">
      <section class="m-linker-spec-hero">
        <h1>Linker</h1>
        <p>Linker의 기술사양</p>
      </section>
      <section class="m-specs-detail">
        <div class="m-spec">
          <p class="m-spec-title">구성</p>
          <div class="m-spec-description">
            <div class="img-container"><img style="width: 91px; height: 92px;" src="@/assets/linker/m-spec-detail-linker.png" alt="">
              <p class="name">링커</p>
            </div>
            <div class="img-container m-mid-img"><img style="width: 43px; height: 73px;" src="@/assets/linker/m-spec-detail-adaptor.png" alt="">
              <p class="name">전원 어댑터</p>
            </div>
            <div class="img-container"><img style="width: 118px; height: 113px;" src="@/assets/linker/m-spec-detail-cable.png" alt="">
              <p class="name">전원 케이블 1.5M</p>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">크기 및 무게</p>
          <div class="m-spec-description">
            <div>
              <p>크기</p>
              <p style="margin-top: 8px">가로: 10cm</p>
              <p>세로: 10cm</p>
              <p>두께: 3.5cm</p>
            </div>
            <div style="vertical-align: top; margin-left: 40px;">
              <p>무게</p>
              <p style="margin-top: 8px">145g</p>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">색상</p>
          <div class="m-spec-description">
            <p>유광 블랙</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">지원 기기</p>
          <div class="m-spec-description">
            <p>iOS, Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">연결</p>
          <div class="m-spec-description">
            <p>적외선(IR)센서 38kHz</p>
            <p>Bluetooth 4.0</p>
            <p>Wi-Fi</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">요구사항</p>
          <div class="m-spec-description">
            <p>Wi-Fi 2.4GHz (5Ghz는 지원 X)</p>
            <p>적외선(IR)이 지원되는 호환기기</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">보안</p>
          <div class="m-spec-description">
            <p>WPA, WPA2, WEP</p>
          </div>
        </div>
      </section>
      <linker-faq></linker-faq>
    </div>
  </div>
</template>
<script>
import LinkerFaq from './LinkerFaq'
export default {
  name: 'linker-spec',
  components: { LinkerFaq }
}
</script>

<style scoped>
.linker-spec-hero {
  background: url("../../../assets/linker/linker-spec-hero.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.spec .linker-spec-title {
  font-size: 24px;
  vertical-align: top;
  width: 15%;
  text-align: left;
  font-weight: 400;
}
.linker-spec-hero span {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10%;
  color: #ffffff;
}
.linker-spec-description {
  display: inline-block;
  width: 45%;
  margin-left: 70px;
  text-align: left;
}
.linker-spec-description div {
  display: inline-block;
}
.linker-spec-description img {
  vertical-align: bottom;
}
.linker-spec-description p {
  font-size: 16px;
  font-weight: 400;
  color: #3d4953;
  margin: 0;
}
.linker-mid-img {
  margin-left: 20px;
  margin-right: 20px;
}
.spec {
  display: flex;
  justify-content: center;
  margin-top: 90px;
}
.spec .spec-title {
  vertical-align: top;
  font-size: 24px;
  width: 15%;
}

.m-mid-img {
  margin-left: 20px;
  margin-right: 20px;
}

.name {
  margin-top: 10px !important;
}

.dimension {
  display: inline-flex;
  justify-content: space-between;
}

.dimension-title {
  vertical-align: top;
}
.dimension-description {
  margin-left: 50px;
  text-align: left;
}
.img-container {
  text-align: center;
}
.m-linker-spec-hero {
  background: url("../../../assets/linker/m-linker-spec-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 449px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-linker-spec-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}
.m-linker-spec-hero p {
  margin: 23px 0px 0px 0px;
  font-size: 18px;
  color: #ffffff;
}
.m-specs-detail {
  padding: 0px 0px 90px 26px;
}
.m-spec {
  text-align: left;
  margin-top: 67px;
}
.m-spec .m-spec-title {
  font-size: 18px;
}

.m-spec-description {
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
  color: #3d4953;
}
.m-spec-description div {
  display: inline-block;
}
.m-spec-description p {
  margin: 0;
}

.m-spec-description img {
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/products/linker/LinkerSpec.vue